import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Box, Collapse, IconButton, TableCell, TableRow } from "@mui/material";
import React from "react";
import { Fragment } from "react/jsx-runtime";

import { GqlCostSpecProtocol } from "~/__generated__";

import ProjectCostProtocolDetails from "../ProjectCostProtocolDetails";

type Props = {
    protocol: GqlCostSpecProtocol;
};

export default function ProjectCostVisitTableRow({ protocol }: Props) {
    const [open, setOpen] = React.useState(false);
    return (
        <Fragment key={protocol.id}>
            <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                </TableCell>
                <TableCell scope="row" component="th">
                    {protocol.name}
                </TableCell>
                <TableCell>{protocol.total}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={3}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            <ProjectCostProtocolDetails protocol={protocol} />
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </Fragment>
    );
}
